import React, { memo, useEffect, useMemo, useState } from "react";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import {
  Button,
  TextField,
  FormControlLabel,
  Checkbox,
  Typography,
  Grid,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Tooltip,
  InputAdornment,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { triggerLoader } from "../../../redux/reducers/LoaderTrigger";
import configServ from "../../../services/config";
import AlertDialog from "../../AlertDialog/AlertDialog";
import CheckAndReturn from "../../../utility/CheckAndReturn";
import AddBrandDialog from "./AddBrandDialog";
import AddCategoryDialog from "./AddCategoryDialog";
import AddGroupDialog from "./AddGroupDialog";
import AddLocationDialog from "./AddLocationDialog";
import AddHsnDialog from "./AddHsnDialog";

function AddItemDialog({ open, handleClose, onItemAdded }) {
  const dispatch = useDispatch();
  const { user_id, company_id, noRoomService } = useSelector(
    (state) => state.GlobalVariables
  );
  const { company_type } = useSelector((state) => state.admin);

  const initialFormData = {
    item_type: "single",
    item_code: "",
    item_name: "",
    brand_id: "",
    category_id: "",
    group_id: "",
    location_id: "",
    unit: "",
    hsncode: "",
    rate_unit: 0,
    costprice: 0,
    openingquantity: "0",
    discount: "0",
    tax_rate: 0,
    description: "",
    sku: "",
    SubscriptionStatus: "Monthly",
    status: true,
    isTaxInclusive: true,
    superCategory: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [formDataInitial, setFormDataInitial] = useState(initialFormData);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [superCategoryList, setSuperCategoryList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [hsnList, setHsnList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [hsn, setHsn] = useState("");

  const [validationErrors, setValidationErrors] = useState({});
  const [isItemName, setIsItemName] = useState(false);
  const [isItemCode, setIsItemCode] = useState(true);

  // Sub-dialogs state
  const [openBrandDialog, setOpenBrandDialog] = useState(false);
  const [openCategoryDialog, setOpenCategoryDialog] = useState(false);
  const [openGroupDialog, setOpenGroupDialog] = useState(false);
  const [openLocationDialog, setOpenLocationDialog] = useState(false);
  const [openHsnDialog, setOpenHsnDialog] = useState(false);

  // Alert Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [title, setTitle] = useState("Alert");
  const [dialogContent, setDialogContent] = useState("");
  const [buttonType, setButtonType] = useState(null);

  const handleOpenDialog = (heading, content, type) => {
    setTitle(heading);
    setDialogContent(content);
    setButtonType(type);
    setDialogOpen(true);
  };

  const handleCloseAlertDialog = () => {
    setDialogOpen(false);
    setTitle("Alert");
    setDialogContent("");
    setButtonType(null);
  };

  const fetchSuperCategory = async () => {
    try {
      const res = await configServ.getSuperCategory();
      if (res && res.data) {
        const superCategoryResponse = res.data.filter((x) => x.status === 1);
        superCategoryResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              superCategory: item.id,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              superCategory: item.id,
            }));
          }
        });
        const result = superCategoryResponse.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setSuperCategoryList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCategory = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getcategory(dataToSend);
      if (res.status === 200) {
        const categoryResponse = res.data.filter((x) => x.status === 1);
        categoryResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              category_id: item.categoryid.toString(),
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              category_id: item.categoryid.toString(),
            }));
          }
        });
        const result = categoryResponse.sort((a, b) =>
          a.categoryname.localeCompare(b.categoryname)
        );
        setCategoryList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchBrand = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getBrand(dataToSend);
      if (res.status === 200) {
        const brand_res = res.data.filter((x) => x.status === 1);
        brand_res.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              brand_id: item.id.toString(),
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              brand_id: item.id.toString(),
            }));
          }
        });
        const result = brand_res.sort((a, b) =>
          a.brand_name.localeCompare(b.brand_name)
        );
        setBrandList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchGroup = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getGroup(dataToSend);
      if (res.status === 200) {
        const groupResponse = res.data.filter((x) => x.status === 1);
        groupResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              group_id: item.id,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              group_id: item.id,
            }));
          }
        });
        const result = groupResponse.sort((a, b) =>
          a.group_name.localeCompare(b.group_name)
        );
        setGroupList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchLocation = async () => {
    try {
      const res = await configServ.getLocation({
        company_id: company_id,
      });
      if (Array.isArray(res)) {
        const locationResponse = res.filter((x) => x.status === 1);
        locationResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              location_id: item.id,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              location_id: item.id,
            }));
          }
        });
        const result = locationResponse.sort((a, b) =>
          a.location_name.localeCompare(b.location_name)
        );
        setLocationList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchUnit = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getUnit(dataToSend);
      if (res.status === 200) {
        const unitResponse = res.data.filter((x) => x.status === 1);
        unitResponse.forEach((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              unit: item.units_name,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              unit: item.units_name,
            }));
          }
        });
        const result = unitResponse.sort((a, b) =>
          a.units_name.localeCompare(b.units_name)
        );
        setUnitList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchGstDetails = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getHsnList(dataToSend);
      if (res.status === 200) {
        const hsnResponse = res.data.filter((x) => x.ActiveFlage === 1);
        hsnResponse.forEach((item) => {
          const hsn_sac = item.hsncode;
          if (item.isPrimary === 1) {
            setHsn(hsn_sac);
            setFormData((prev) => ({
              ...prev,
              hsncode: hsn_sac,
              tax_rate: item.GSTRate,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              hsncode: hsn_sac,
              tax_rate: item.GSTRate,
            }));
          }
        });
        setHsnList(hsnResponse);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const clear = () => {
    setFormData(formDataInitial);
    setIsItemName(false);
    setIsItemCode(true);
    fetchGstDetails();
    setValidationErrors({});
  };

  const handleModalClose = () => {
    clear();
    handleClose();
  };

  useEffect(() => {
    if (open) {
      clear();
      fetchSuperCategory();
      fetchCategory();
      fetchBrand();
      fetchGroup();
      fetchUnit();
      fetchGstDetails();
      fetchLocation();
    }
  }, [open]);

  // Sub-dialog callbacks
  const handleBrandAdded = async (newBrand) => {
    await fetchBrand();
    if (newBrand) {
      setBrandList((prev) => {
        const exists = prev.some(
          (b) => b.id.toString() === newBrand.id.toString()
        );
        if (exists) {
          return prev.map((b) =>
            b.id.toString() === newBrand.id.toString() ? newBrand : b
          );
        }
        return [...prev, newBrand];
      });
      setFormData((prev) => ({
        ...prev,
        brand_id: newBrand.id.toString(),
      }));
      setValidationErrors((prev) => ({
        ...prev,
        brand_id: "",
      }));
    }
  };

  const handleCategoryAdded = async (newCategory) => {
    await fetchCategory();
    if (newCategory) {
      const catId = (newCategory.categoryid || newCategory.id).toString();
      const formattedCat = {
        ...newCategory,
        categoryid: catId,
        categoryname: newCategory.categoryname,
      };
      setCategoryList((prev) => {
        const exists = prev.some(
          (c) => (c.categoryid || c.id || "").toString() === catId
        );
        if (exists) {
          return prev.map((c) =>
            (c.categoryid || c.id || "").toString() === catId ? formattedCat : c
          );
        }
        return [...prev, formattedCat];
      });
      setFormData((prev) => ({
        ...prev,
        category_id: catId,
      }));
      setValidationErrors((prev) => ({
        ...prev,
        category_id: "",
      }));
    }
  };

  const handleGroupAdded = async (newGroup) => {
    await fetchGroup();
    if (newGroup) {
      setGroupList((prev) => {
        const exists = prev.some(
          (g) => g.id.toString() === newGroup.id.toString()
        );
        if (exists) {
          return prev.map((g) =>
            g.id.toString() === newGroup.id.toString() ? newGroup : g
          );
        }
        return [...prev, newGroup];
      });
      setFormData((prev) => ({
        ...prev,
        group_id: newGroup.id,
      }));
      setValidationErrors((prev) => ({
        ...prev,
        group_id: "",
      }));
    }
  };

  const handleLocationAdded = async (newLocation) => {
    await fetchLocation();
    if (newLocation) {
      setLocationList((prev) => {
        const exists = prev.some(
          (l) => l.id.toString() === newLocation.id.toString()
        );
        if (exists) {
          return prev.map((l) =>
            l.id.toString() === newLocation.id.toString() ? newLocation : l
          );
        }
        return [...prev, newLocation];
      });
      setFormData((prev) => ({
        ...prev,
        location_id: newLocation.id,
      }));
      setValidationErrors((prev) => ({
        ...prev,
        location_id: "",
      }));
    }
  };

  const handleHsnAdded = async (newHsn) => {
    await fetchGstDetails();
    if (newHsn) {
      setHsnList((prev) => {
        const exists = prev.some(
          (h) =>
            (h.hsncode || "").toString() === (newHsn.hsncode || "").toString()
        );
        if (exists) {
          return prev.map((h) =>
            (h.hsncode || "").toString() === (newHsn.hsncode || "").toString()
              ? newHsn
              : h
          );
        }
        return [...prev, newHsn];
      });
      setHsn(newHsn.hsncode);
      setFormData((prev) => ({
        ...prev,
        hsncode: newHsn.hsncode,
        tax_rate: newHsn.GSTRate,
      }));
      setValidationErrors((prev) => ({
        ...prev,
        hsncode: "",
        tax_rate: "",
      }));
    }
  };

  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: value,
    }));

    if (validationErrors[name]) {
      setValidationErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const checkHandler = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));
  };

  const handleHSN = (selectedhsn) => {
    if (selectedhsn === null) {
      setHsn("");
      setFormData((state) => ({
        ...state,
        hsncode: "",
        tax_rate: "",
      }));
    } else {
      const matched = hsnList.find(
        (x) => x.hsncode.toString() === selectedhsn.hsncode.toString()
      );
      if (matched) {
        setHsn(matched.hsncode);
        setFormData((state) => ({
          ...state,
          hsncode: matched.hsncode,
          tax_rate: matched.GSTRate,
        }));
      }
    }
  };

  const calculatedBillableRate = useMemo(() => {
    const unitPrice = parseFloat(formData.rate_unit) || 0;
    const taxRate = parseFloat(formData.tax_rate) || 0;
    const discount = parseFloat(formData.discount) || 0;
    const isInclusive = formData.isTaxInclusive;

    let basePrice;
    if (isInclusive) {
      basePrice = unitPrice / (1 + taxRate / 100);
      const discountedBase = basePrice - (basePrice * discount) / 100;
      return Math.round(discountedBase);
    } else {
      const discountedPrice = unitPrice - (unitPrice * discount) / 100;
      return Math.round(discountedPrice);
    }
  }, [
    formData.rate_unit,
    formData.tax_rate,
    formData.discount,
    formData.isTaxInclusive,
  ]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      billable_rate: calculatedBillableRate,
    }));
  }, [calculatedBillableRate]);

  const checkItemCode = async () => {
    try {
      const dataToSend = {
        item_code: formData.item_code,
      };
      const res = await configServ.checkItemCode(dataToSend);
      if (res.status === 200) {
        setIsItemCode(true);
      } else {
        setIsItemCode(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (formData.item_code && formData.item_code.length > 3) {
      checkItemCode();
    } else if (formData.item_code && formData.item_code.length < 4) {
      setIsItemCode(false);
    } else if (CheckAndReturn.checkError(formData.item_code)) {
      setIsItemCode(true);
    } else {
      setIsItemCode(false);
    }
  }, [formData.item_code]);

  const checkItemName = async () => {
    try {
      const dataToSend = {
        item_name: formData.item_name,
      };
      const res = await configServ.checkItemName(dataToSend);
      if (res.status === 200) {
        setIsItemName(true);
      } else {
        setIsItemName(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (formData.item_name) {
      checkItemName();
    }
  }, [formData.item_name]);

  const handleFormValidation = () => {
    const errors = {};
    if (!formData.brand_id) {
      errors.brand_id = "required";
    }
    if (!formData.category_id) {
      errors.category_id = "required";
    }
    if (!formData.group_id) {
      errors.group_id = "required";
    }
    if (!formData.location_id) {
      errors.location_id = "required";
    }
    if (!formData.item_name) {
      errors.item_name = "required";
    } else if (!isItemName) {
      errors.item_name = "required";
    }
    if (!isItemCode) {
      errors.item_code = "required";
    }
    if (CheckAndReturn.checkError(formData.hsncode)) {
      errors.hsncode = "required";
    }
    if (!formData.unit) {
      errors.unit = "required";
    }
    if (CheckAndReturn.checkError(formData.openingquantity)) {
      errors.openingquantity = "required";
    }
    if (CheckAndReturn.checkError(formData.discount)) {
      errors.discount = "required";
    }
    if (CheckAndReturn.checkError(formData.tax_rate)) {
      errors.tax_rate = "required";
    }
    if (CheckAndReturn.checkError(formData.rate_unit)) {
      errors.rate_unit = "required";
    }
    if (CheckAndReturn.checkError(formData.costprice)) {
      errors.costprice = "required";
    }
    setValidationErrors(errors);
    return Object.values(errors).every((error) => error === "");
  };

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();

    try {
      const isValid = handleFormValidation();
      if (!isValid) {
        return false;
      }

      dispatch(triggerLoader());
      const itemData = {
        ...formData,
        items: [],
        hsncode: hsn || formData.hsncode,
        type: company_type || "product",
        company_id: company_id,
        user_id: user_id,
      };

      const res = await configServ.createItem(itemData);
      if (res.status === 200) {
        clear();
        if (onItemAdded) {
          onItemAdded(res.data);
        }
        handleClose();
      } else if (res.status === 400) {
        handleOpenDialog(
          "Warning",
          res.message || "Failed to create item",
          "warning"
        );
      } else {
        handleOpenDialog("Error", res.message || "Failed to create item.", "error");
      }
    } catch (e) {
      console.log(e);
      handleOpenDialog("Error", "An unexpected error has occurred.", "error");
    } finally {
      dispatch(triggerLoader());
    }
  };

  const handleLabel = (label) => (
    <span>
      {label}
      <span style={{ color: "red" }}>*</span>
    </span>
  );

  return (
    <>
      <AlertDialog
        open={dialogOpen}
        setOpen={handleCloseAlertDialog}
        title={title}
        message={dialogContent}
        buttonTitle="Ok"
        buttonType={buttonType}
      />

      <AddBrandDialog
        open={openBrandDialog}
        handleClose={() => setOpenBrandDialog(false)}
        onBrandAdded={handleBrandAdded}
      />

      <AddCategoryDialog
        open={openCategoryDialog}
        handleClose={() => setOpenCategoryDialog(false)}
        onCategoryAdded={handleCategoryAdded}
      />

      <AddGroupDialog
        open={openGroupDialog}
        handleClose={() => setOpenGroupDialog(false)}
        onGroupAdded={handleGroupAdded}
      />

      <AddLocationDialog
        open={openLocationDialog}
        handleClose={() => setOpenLocationDialog(false)}
        onLocationAdded={handleLocationAdded}
      />

      <AddHsnDialog
        open={openHsnDialog}
        handleClose={() => setOpenHsnDialog(false)}
        onHsnAdded={handleHsnAdded}
      />

      <Dialog
        open={open}
        onClose={handleModalClose}
        maxWidth="lg"
        fullWidth
        scroll="paper"
      >
        <DialogTitle sx={{ backgroundColor: "#e3f3fc", py: 1.5 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" fontWeight="bold" color="#1e61b4">
              Add New Item
            </Typography>
            <IconButton onClick={handleModalClose} size="small">
              <CloseIcon />
            </IconButton>
          </Stack>
        </DialogTitle>

        <DialogContent dividers sx={{ backgroundColor: "#f9fbfe", py: 2 }}>
          <Grid container spacing={2}>
            {/* Header: Item Detail */}
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "bold", color: "#1e61b4" }}
              >
                Item Detail
              </Typography>
            </Grid>

            {/* Brand Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                size="small"
                sx={{ backgroundColor: "white" }}
                id="brand"
                options={brandList}
                getOptionLabel={(option) => option.brand_name || ""}
                value={
                  brandList.find(
                    (item) =>
                      item.id.toString() ===
                      (formData.brand_id || "").toString()
                  ) || null
                }
                onChange={(event, newValue) => {
                  changeHandler({
                    target: {
                      name: "brand_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                noOptionsText={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="body2">No Brand Found</Typography>
                    <Button
                      size="small"
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setOpenBrandDialog(true)}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        py: 0.25,
                        px: 1,
                      }}
                    >
                      Add Brand
                    </Button>
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="brand_id"
                    label={handleLabel("Brand")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.brand_id}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <Tooltip title="Add New Brand">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenBrandDialog(true);
                              }}
                              sx={{ color: "primary.main", p: 0.25 }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Category Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="category"
                size="small"
                sx={{ backgroundColor: "white" }}
                options={categoryList}
                getOptionLabel={(option) => option.categoryname || ""}
                value={
                  categoryList.find(
                    (item) =>
                      (item.categoryid || item.id || "").toString() ===
                      (formData.category_id || "").toString()
                  ) || null
                }
                onChange={(event, newValue) => {
                  changeHandler({
                    target: {
                      name: "category_id",
                      value: newValue
                        ? (newValue.categoryid || newValue.id).toString()
                        : "",
                    },
                  });
                }}
                noOptionsText={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="body2">No Category Found</Typography>
                    <Button
                      size="small"
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setOpenCategoryDialog(true)}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        py: 0.25,
                        px: 1,
                      }}
                    >
                      Add Category
                    </Button>
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="category_id"
                    label={handleLabel("Category")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.category_id}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <Tooltip title="Add New Category">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenCategoryDialog(true);
                              }}
                              sx={{ color: "primary.main", p: 0.25 }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Group Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="group"
                size="small"
                sx={{ backgroundColor: "white" }}
                options={groupList}
                getOptionLabel={(option) => option.group_name || ""}
                value={
                  groupList.find((item) => item.id === formData.group_id) ||
                  null
                }
                onChange={(event, newValue) => {
                  changeHandler({
                    target: {
                      name: "group_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                noOptionsText={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="body2">No Group Found</Typography>
                    <Button
                      size="small"
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setOpenGroupDialog(true)}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        py: 0.25,
                        px: 1,
                      }}
                    >
                      Add Group
                    </Button>
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="group_id"
                    label={handleLabel("Group")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.group_id}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <Tooltip title="Add New Group">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenGroupDialog(true);
                              }}
                              sx={{ color: "primary.main", p: 0.25 }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Location Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="location"
                size="small"
                sx={{ backgroundColor: "white" }}
                options={locationList}
                getOptionLabel={(option) => option.location_name || ""}
                value={
                  locationList.find(
                    (item) => item.id === formData.location_id
                  ) || null
                }
                onChange={(event, newValue) => {
                  changeHandler({
                    target: {
                      name: "location_id",
                      value: newValue?.id || "",
                    },
                  });
                }}
                noOptionsText={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="body2">No Location Found</Typography>
                    <Button
                      size="small"
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setOpenLocationDialog(true)}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        py: 0.25,
                        px: 1,
                      }}
                    >
                      Add Location
                    </Button>
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="location_id"
                    label={handleLabel("Location")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.location_id}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <Tooltip title="Add New Location">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenLocationDialog(true);
                              }}
                              sx={{ color: "primary.main", p: 0.25 }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* Item Name */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="item_name"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="item_name"
                label={handleLabel("Item Name")}
                variant="outlined"
                fullWidth
                value={formData.item_name || ""}
                onChange={changeHandler}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isItemName ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </InputAdornment>
                  ),
                }}
                error={!!validationErrors.item_name}
              />
            </Grid>

            {/* Item Code */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="item_code"
                name="item_code"
                label="Item Code"
                variant="outlined"
                fullWidth
                size="small"
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.item_code
                )}
                onChange={changeHandler}
                error={!!validationErrors.item_code}
                sx={{ backgroundColor: "white" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {isItemCode ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Item Type */}
            <Grid item xs={12} sm={6} md={3}>
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel id="itemType-label">Item Type</InputLabel>
                <Select
                  id="itemType"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  name="item_type"
                  value={formData.item_type || "single"}
                  onChange={changeHandler}
                  label="Item Type"
                >
                  <MenuItem value="single">Single</MenuItem>
                  <MenuItem value="composite">Composite</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {/* Super Category (if noroomService) */}
            {noRoomService === "noroom" && (
              <Grid item xs={12} sm={6} md={3}>
                <Autocomplete
                  id="superCategory"
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  options={superCategoryList}
                  getOptionLabel={(option) => option.name || ""}
                  value={
                    superCategoryList.find(
                      (item) => item.id === formData.superCategory
                    ) || null
                  }
                  onChange={(event, newValue) => {
                    changeHandler({
                      target: {
                        name: "superCategory",
                        value: newValue?.id || "",
                      },
                    });
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      name="superCategory"
                      label="Super Category"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                />
              </Grid>
            )}

            {/* Item Description */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="itemDescription"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="description"
                label="Item Description"
                variant="outlined"
                fullWidth
                value={formData.description || ""}
                onChange={changeHandler}
              />
            </Grid>

            {/* Header: Price Detail */}
            <Grid item xs={12}>
              <Typography
                sx={{ fontSize: "16px", fontWeight: "bold", color: "#1e61b4", mt: 1 }}
              >
                Price Detail
              </Typography>
            </Grid>

            {/* HSN / SAC Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="hsncode"
                size="small"
                sx={{ backgroundColor: "white" }}
                options={hsnList}
                getOptionLabel={(option) =>
                  option.hsncode ? option.hsncode.toString() : ""
                }
                value={
                  hsnList.find(
                    (item) =>
                      (item.hsncode || "").toString() ===
                      (formData.hsncode || "").toString()
                  ) || null
                }
                onChange={(event, newValue) => {
                  handleHSN(newValue);
                }}
                noOptionsText={
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                    width="100%"
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="body2">No HSN Found</Typography>
                    <Button
                      size="small"
                      startIcon={<AddIcon />}
                      variant="contained"
                      color="primary"
                      onMouseDown={(e) => e.preventDefault()}
                      onClick={() => setOpenHsnDialog(true)}
                      sx={{
                        textTransform: "none",
                        fontSize: "0.75rem",
                        py: 0.25,
                        px: 1,
                      }}
                    >
                      Add HSN
                    </Button>
                  </Box>
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="hsncode"
                    label={handleLabel("HSN/SAC")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.hsncode}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          <Tooltip title="Add New HSN">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setOpenHsnDialog(true);
                              }}
                              sx={{ color: "primary.main", p: 0.25 }}
                            >
                              <AddIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
              />
            </Grid>

            {/* SKU */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="sku"
                name="sku"
                label="SKU"
                variant="outlined"
                fullWidth
                size="small"
                value={formData.sku || ""}
                onChange={changeHandler}
                sx={{ backgroundColor: "white" }}
              />
            </Grid>

            {/* Unit Dropdown */}
            <Grid item xs={12} sm={6} md={3}>
              <Autocomplete
                id="unit"
                size="small"
                sx={{ backgroundColor: "white" }}
                options={unitList}
                getOptionLabel={(option) => option.units_name || ""}
                value={
                  unitList.find(
                    (item) => item.units_name === formData.unit
                  ) || null
                }
                onChange={(event, newValue) => {
                  changeHandler({
                    target: {
                      name: "unit",
                      value: newValue?.units_name || "",
                    },
                  });
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="unit"
                    label={handleLabel("Unit")}
                    variant="outlined"
                    fullWidth
                    error={!!validationErrors.unit}
                  />
                )}
              />
            </Grid>

            {/* Unit Price */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="unitPrice"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="rate_unit"
                label={handleLabel("Unit Price")}
                variant="outlined"
                type="number"
                fullWidth
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.rate_unit
                )}
                onChange={changeHandler}
                error={!!validationErrors.rate_unit}
              />
            </Grid>

            {/* Inclusive Tax Checkbox */}
            <Grid item xs={12} sm={6} md={3} display="flex" alignItems="center">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={formData.isTaxInclusive}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        isTaxInclusive: e.target.checked,
                      }))
                    }
                    name="isTaxInclusive"
                  />
                }
                label="Inclusive Tax"
              />
            </Grid>

            {/* Billable Rate (Calculated) */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                label="Billable Rate"
                value={calculatedBillableRate}
                fullWidth
                disabled
                size="small"
                sx={{ backgroundColor: "#f5f5f5" }}
              />
            </Grid>

            {/* Opening Quantity */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="openingQuantity"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="openingquantity"
                label={handleLabel("Opening Quantity")}
                type="number"
                variant="outlined"
                fullWidth
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.openingquantity
                )}
                onChange={changeHandler}
                error={!!validationErrors.openingquantity}
              />
            </Grid>

            {/* Discount (%) */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="discount"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="discount"
                label={handleLabel("Discount(%)")}
                type="number"
                variant="outlined"
                fullWidth
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.discount
                )}
                onChange={changeHandler}
                error={!!validationErrors.discount}
              />
            </Grid>

            {/* Tax Rate (%) */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="taxRate"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="tax_rate"
                label={handleLabel("Tax Rate")}
                variant="outlined"
                type="number"
                fullWidth
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.tax_rate
                )}
                onChange={changeHandler}
                error={!!validationErrors.tax_rate}
              />
            </Grid>

            {/* Cost Price */}
            <Grid item xs={12} sm={6} md={3}>
              <TextField
                id="costPrice"
                size="small"
                sx={{ backgroundColor: "white" }}
                name="costprice"
                label={handleLabel("Cost Price")}
                variant="outlined"
                type="number"
                fullWidth
                value={CheckAndReturn.checkTextNullAndUndefined(
                  formData.costprice
                )}
                onChange={changeHandler}
                error={!!validationErrors.costprice}
              />
            </Grid>

            {/* Status */}
            <Grid item xs={12} sm={6} md={3} display="flex" alignItems="center">
              <FormControlLabel
                name="status"
                control={
                  <Checkbox
                    checked={Boolean(formData.status) || false}
                    onChange={checkHandler}
                  />
                }
                label="Status"
              />
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions sx={{ backgroundColor: "#e3f3fc", px: 3, py: 1.5 }}>
          <Button
            onClick={clear}
            variant="contained"
            color="secondary"
            startIcon={<RotateLeftIcon />}
            sx={{ mx: 1 }}
          >
            Reset
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmit}
            startIcon={<SaveIcon />}
            color="primary"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default memo(AddItemDialog);
